import { api } from '../api'
import { AnalyticsServiceSettings } from 'models/AnalyticsServiceSettings'

export const analyticsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAnalyticsSettings: builder.query<
      AnalyticsServiceSettings[],
      { campaignId: string; organizationId: string }
    >({
      query: ({ campaignId, organizationId }) =>
        `/analytics-settings/${campaignId}/${organizationId}`,
    }),
  }),
})

export const {
  endpoints: { getAnalyticsSettings },
  useGetAnalyticsSettingsQuery,
} = analyticsApi
